"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Image.css");
var Image = (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this._fallback = function () {
            if (_this.props.fallbackSrc) {
                _this.setState({ failed: true });
            }
        };
        _this.state = { failed: false };
        _this._fallback = _this._fallback.bind(_this);
        _this._customizeEnums = _this._customizeEnums.bind(_this);
        return _this;
    }
    Image.prototype._customizeEnums = function (en) {
        var cases = {
            "White": "white-overlay",
            "Black": "black-overlay",
            "Primary": "primary30",
            "Brand": "primary50",
            "Secondary": "secondary30",
            "Success": "success30",
            "Warning": "warning30",
            "Error": "error30",
            "Info": "info30"
        };
        return cases[en] ? cases[en] : en.toLowerCase().replace(' ', '-');
    };
    ;
    Image.prototype.render = function () {
        var _a = this.props, size = _a.size, width = _a.width, height = _a.height, cornerStyle = _a.cornerStyle, tag = _a.tag, src = _a.src, fallbackSrc = _a.fallbackSrc, tooltip = _a.tooltip, alt = _a.alt, hasOverlay = _a.hasOverlay, overlayColor = _a.overlayColor, overlayStrength = _a.overlayStrength, customOverlayColor = _a.customOverlayColor, overlayMinHeight = _a.overlayMinHeight, shouldFlipForRtl = _a.shouldFlipForRtl, backgroundColor = _a.backgroundColor;
        var failed = this.state.failed;
        var cssClasses = [];
        var overlayStyle = {};
        var overlayColorStr = '';
        var sizing = {};
        var finalSrc = failed ? fallbackSrc : src;
        if (width || height) {
            cssClasses.push("p-image");
        }
        else {
            cssClasses.push("p-image-" + size.toLowerCase());
        }
        if (cornerStyle.toLowerCase() !== 'none') {
            cssClasses.push("p-image-" + cornerStyle.toLowerCase());
        }
        if (shouldFlipForRtl)
            cssClasses.push('p-flip-rtl');
        if (backgroundColor) {
            cssClasses.push("p-bg-" + this._customizeEnums(backgroundColor));
        }
        var imgClassString = cssClasses.join(' ');
        if (width)
            sizing['width'] = width;
        if (height)
            sizing['height'] = height;
        if (hasOverlay) {
            var overlayImgClassStr = imgClassString + " block-display";
            var overlayClass = 'overlay overlay' + (overlayStrength.toLowerCase() === 'light' ? '-light' : '-heavy');
            if (overlayColor && customOverlayColor === '') {
                overlayColorStr = 'p-bg-' + this._customizeEnums(overlayColor);
            }
            var overlayStyles = {};
            if (overlayMinHeight) {
                overlayStyles['min-height'] = overlayMinHeight;
            }
            return (React.createElement("div", { className: "p-image-overlay-wrapper", style: overlayStyles },
                React.createElement("img", { className: overlayImgClassStr, src: finalSrc, "data-tag": tag, onError: this._fallback, title: tooltip, alt: alt, style: sizing }),
                React.createElement("div", { className: overlayClass + " " + overlayColorStr, style: customOverlayColor ? { backgroundColor: "" + customOverlayColor } : {} })));
        }
        return (React.createElement("img", { className: imgClassString, src: finalSrc, title: tooltip, alt: alt, "data-tag": tag, onError: this._fallback, style: sizing }));
    };
    return Image;
}(React.Component));
Image.defaultProps = {
    src: '',
    fallbackSrc: '',
    size: 'Block',
    width: '',
    height: '',
    tooltip: '',
    alt: '',
    cornerStyle: 'None',
    tag: null,
    hasOverlay: false,
    overlayColor: 'Black',
    overlayStrength: 'Light',
    customOverlayColor: '',
    overlayMinHeight: '',
    shouldFlipForRtl: false,
    backgroundColor: ''
};
exports.Image = Image;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['Image'] = Image;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Image"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Image/index.js
// module id = 74
// module chunks = 0 2